module.exports = __webpack_public_path__ + "static/media/boek_09.77ca8cb0.png";